import React from 'react';
import PropTypes from 'prop-types';

const Overlay = ({ children, onClose }) => {
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
            onClick={handleOverlayClick}
        >
            <div className="relative">
                {children}
            </div>
        </div>
    );
};

Overlay.propTypes = {
    children: PropTypes.node.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default Overlay;